import { RtJsonDate } from "@aprao/common/src/runtypes/common.js";
import { z } from "zod";

import type { ShapeMe } from "../shapes/ShapeOrganization.js";
import { RtAppraisalDocument } from "./RtAppraisal.js";
import { RtProject } from "./RtProject.js";

export const RtReportData = z.strictObject({
  project: RtProject,
  appraisalDocument: RtAppraisalDocument,
  updatedDate: RtJsonDate,
  mapImageUrl: z.string().nullable(),
  logoUrl: z.string().nullable(),
  /**
   * Should the extra analyses be shown on the report?
   *
   * They are behind the feature flag
   * {@link ShapeMe.featureSettings.isOperatedAssetSensitivityAnalysesEnabled} but
   * since the discriminant is the owner of the report (not necessarily the user
   * looking at it), we bundle it with the report data.
   */
  isOperatedAssetSensitivityAnalysesEnabled: z.boolean(),
});

export const RtSharingLinkDetails = z.object({
  id: z.string(),
  timestamp: z.string(),
  check: z.string(),
});

export const RtSharedReportData = RtReportData.extend({
  sharingLinkDetails: RtSharingLinkDetails,
});
